/**
 * Runtime configuration shim — same pattern as apps/employee.
 * Resolution order:
 *   window.__APP_CONFIG__.<KEY>   →   import.meta.env.VITE_<KEY>   →   default
 */

interface AppConfig {
  KEYCLOAK_URL?: string
  KEYCLOAK_REALM?: string
  KEYCLOAK_CLIENT_ID?: string
  MANAGER_API_URL?: string
}

declare global {
  interface Window {
    __APP_CONFIG__?: AppConfig
  }
}

function pick(key: keyof AppConfig, viteKey: string, fallback: string): string {
  const runtime = (typeof window !== 'undefined' && window.__APP_CONFIG__?.[key]) || ''
  if (runtime) return runtime
  const fromVite = (import.meta.env as Record<string, string | undefined>)[viteKey]
  if (fromVite) return fromVite
  return fallback
}

export const RUNTIME_CONFIG = {
  KEYCLOAK_URL: pick('KEYCLOAK_URL', 'VITE_KEYCLOAK_URL', ''),
  KEYCLOAK_REALM: pick('KEYCLOAK_REALM', 'VITE_KEYCLOAK_REALM', 'employee'),
  KEYCLOAK_CLIENT_ID: pick('KEYCLOAK_CLIENT_ID', 'VITE_KEYCLOAK_CLIENT_ID', 'manager-portal'),
  MANAGER_API_URL: pick('MANAGER_API_URL', 'VITE_MANAGER_API_URL', ''),
} as const
